import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BasicFileInput } from "core/components";
import { ApplicationEditLayout, Content } from "core/layouts";

function ConfirmingReportFileUploadTemplate({ confirmingReportFileUploadViewStore }) {
    const {
        contentLoading,
        form
    } = confirmingReportFileUploadViewStore;

    return (
        <ApplicationEditLayout store={confirmingReportFileUploadViewStore}>
            <Content loading={contentLoading}>
                <div className="row">
                    <div className="col col-sml-12 col-lrg-4">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                        <BasicFileInput field={form.$('file')} accept=".csv"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    );
}

ConfirmingReportFileUploadTemplate.propTypes = {
    confirmingReportFileUploadViewStore: PropTypes.object
};

export default defaultTemplate(ConfirmingReportFileUploadTemplate);